export const permissions = {
  all: [
    "operator",
    "user",
    "campaign",
    "company",
    "member",
    "billing",
    "transaction",
    "accepted-point",
  ],
  master: ["operator", "user"],
  operator: ["company", "billing", "user"],
  company: [
    "pos",
    "member",
    "campaign",
    "acceptance-point",
    "transaction",
    "user",
  ],
};
